{
  "LC_POKOK": { "label": "Pokok", "gloss": "Trees" },
  "LC_RUMPUT": { "label": "Rumput", "gloss": "Grass" },
  "LC_TURAPAN": { "label": "Turapan", "gloss": "Paved surface" },
  "LC_BANGUNAN": { "label": "Bangunan", "gloss": "Building" },
  "LC_JALAN": { "label": "Jalan Raya", "gloss": "Road" },
  "LC_PERTANIAN": { "label": "Pertanian", "gloss": "Agriculture" },
  "LC_TANAH_KOSONG": { "label": "Tanah Kosong", "gloss": "Bare land" },
  "LC_AIR": { "label": "Air", "gloss": "Water" }
}
